import moment from "moment-timezone";
import { ISession } from "../../../../models/session";
moment.tz.setDefault("Asia/Jerusalem");

export const formatMonth = (date: Date, language: string) => {
    if (language) {
        const formatMonth = new Intl.DateTimeFormat(language.toLowerCase().substring(0, 2), { month: "long" });

        if (language === "English") {
            return formatMonth.format(date).substring(0, 3).toUpperCase();
        } else if (language === "Hebrew") {
            return formatMonth.format(date).substring(0, 3);
        } else {
            return formatMonth.format(date);
        }
    }
};

export const formatTime = (time: string, language: string) => {
    if (language) {
        if (language === "English") {
            return moment(time, ["h:mm A"]).format("h:mm A");
        } else {
            return moment(time, ["h:mm A"]).format("HH:mm");
        }
    }
};

export const formatDay = (date: Date) =>
    moment(new Date(date)).format("DD")


export const formatDateForCalendar = (date: string) =>
    moment(date, ["h:mm A"]).format("HH:mm").toString()

export const navigateToContent = (id: string) => {
    window.open(`/content/${id}`, "_self")?.focus();
};

export const isSessionArray = (session: ISession | ISession[]): session is ISession[] => {
    return Array.isArray(session);
};